import { useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { blogRoutes } from './allRoutes';
import { getLoggedUserPermissions } from '../services/configuration.service';

const switchRoutes = (
  <Switch>
    {blogRoutes.map((prop, key) => {
      if (prop.layout === 'blog') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/blog" to="/blog/list" />
  </Switch>
);

const Blog = () => {
  const { user } = useUserAuth();
  const [existNudosData, setExistNudosData] = useState<boolean>(false);
  const getNudosData = async () => {
    if (!localStorage.getItem('userNudosData') && user) {
      const nudosData = await getLoggedUserPermissions(user?.uid);
      localStorage.setItem('userNudosData', JSON.stringify(nudosData));
      setExistNudosData(true);
    } else if (localStorage.getItem('userNudosData') && user) {
      setExistNudosData(true);
    }
  };

  useEffect(() => {
    getNudosData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  return <> {user && existNudosData && switchRoutes} </>;
};

export default Blog;
